/* unplugin-vue-components disabled */import script from "./DeleteEntries.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteEntries.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__